import {
  all, call, put, select, takeEvery,
} from 'redux-saga/effects';

import { request } from 'utils/request';
import { IRestApiResponse } from 'interfaces';
import { authSliceActions } from 'base/auth/slice';
import { getCurrentTenant } from 'utils/common-utils';
import { selectAuthUser } from 'base/auth/selectors';
import { CoreSliceActions } from 'base/core/slice';
import { selectEnterprise } from 'base/core/selectors';
import { CategoryResourceType } from 'constants/sessions';
import API from '../../constants';
import { IUpdateProfileStateAction } from './interface';
import { editProfileActions } from './slice';

function* assignCategories(resourceId: string, categories: string[]) {
  yield call(
    request,
    API.POST_ASSIGN_CATEGORIES,
    {
      resourceId,
      categoryId: categories,
      resourceType: CategoryResourceType.EXPERT,
    },
  );
}

export function* updateProfileGenerator({ payload }: IUpdateProfileStateAction): any {
  try {
    const expert = yield select(selectAuthUser);
    const enterprise = yield select(selectEnterprise);

    const data: any = {
      entId: enterprise.id,
      entUrl: getCurrentTenant(),
      firstName: payload.firstName,
      lastName: payload.lastName,
      email: payload.email,
      bio: payload.bio,
      profileImgUrl: payload.profileImgUrl,
      attributes: {
        isActive: true,
        accountType: payload.accountType,
        category: payload.category,
        introVideoUrl: payload.introVideoUrl,
        thankVideoUrl: payload.thankVideoUrl,
        rateVideoUrl: payload.rateVideoUrl,
        sponsorContent: payload.sponsors,
        achievements: payload.achievements,
        statistics: payload.statistics,
        currency: payload.currency,
        subscriptionFrequency: payload.subscriptionFrequency,
        subscriptionFee:
          payload.subscriptionFee === ''
            ? '0.00'
            : Number(payload.subscriptionFee).toFixed(2).toLocaleString(),
        badges: payload.badges,
      },
    };
    const response: IRestApiResponse = yield call(request, API.POST_UPDATE_EXPERT, data, true);
    if (response.statusCode === 201) {
      const { categories } = payload;
      yield assignCategories(expert.id, categories);
      yield put(authSliceActions.fetchUser());
      if (expert.email !== payload.email) {
        yield put(CoreSliceActions.setMessage({ message: 'Redirecting....', success: true }));
        yield put(authSliceActions.signOut());
      } else {
        yield put(authSliceActions.fetchUser());
      }
    } else {
      yield put(editProfileActions.updateProfileFailed());
    }
  } catch (error) {
    yield put(editProfileActions.updateProfileFailed());
  }
}

export function* updateProfileSaga() {
  yield all([
    takeEvery(editProfileActions.updateProfile.type, updateProfileGenerator),
  ]);
}

export default updateProfileSaga;
